import { Alert, Link, Typography } from "@mui/material";
import { useAppConfig } from "../../../config/app-config";
import { Trademark } from "../../dataDisplay/Trademark";

export const ColorFilterNcsExplanation = () => {
  const [config] = useAppConfig();

  return (
    <Alert severity="info">
      The results of this search show the best matches with the official NCS
      <Trademark>®©</Trademark> color specification. The color system and color
      system code specified by Covestro for a color grade combination may differ
      from this best match as they may reflect different customer acceptance
      requirements.
      <Typography fontSize="1em" fontWeight={700}>
        <Link
          underline="hover"
          target="_blank"
          href={config.documentation.colorSystemSpecifications}
        >
          Learn more about color system specifications.
        </Link>
      </Typography>
    </Alert>
  );
};
